if (!customElements.get('faq-category-tabs-component')) {
  customElements.define(
    'faq-category-tabs-component',
    class FaqCategoryTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('.faq-category-tabs__tab'));
        this.items = Array.from(this.querySelectorAll('.faq-category-tabs__item'));
        this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick.bind(this)));
      }

      handleTabClick(event) {
        const selectedTab = event.currentTarget;
        const category = selectedTab.dataset.category;

        this.tabs.forEach((tab) => {
          const isActive = tab === selectedTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });

        this.items.forEach((item) => {
          const matches = category === 'all' || item.dataset.category === category;
          item.hidden = !matches;
          if (!matches) item.removeAttribute('open');
        });
      }
    }
  );
}
